<script setup lang="ts">
const { data: me } = await useFetch('/api/me')

const links = [
  {
    label: 'Registrations',
    to: '/rope-admin/'
  }, {
    label: 'Attendees',
    to: '/rope-admin/person-list'
  }, {
    label: 'Supported',
    to: '/rope-admin/supported'
  },
]

</script>

<template>
  <UContainer :ui="{
    constrained: me.type == 'admin' ? 'max-w-screen' : 'container'
  }">
    <UHorizontalNavigation 
      v-if="me.type == 'admin'"
      :links="links" 
      class="border-b border-gray-200 dark:border-gray-800"
    />

    <UCard class="my-10">
      <template #header>
        Ellipsis Rope Events
      </template>

    <slot />
  </UCard>
    
  </UContainer>
</template>